import { Navigate, Outlet, useLocation } from 'react-router-dom'
import routes from '../../../config/routes'
import { useIsLogged } from '../../../modules/auth/hooks'

export const PrivateLayout = () => {
  const location = useLocation()
  const { isCheckingLogin, isLogged } = useIsLogged()

  if (isCheckingLogin) {
    return null
  }

  if (!isLogged) {
    return (
      <Navigate
        to={{
          pathname: routes.app,
          search: location.search,
        }}
        state={{ from: location }}
        replace
      />
    )
  }

  return <Outlet />
}
